import script from "./AppLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayout.vue?vue&type=style&index=0&id=ba8f12ba&lang=css"

const __exports__ = script;

export default __exports__